import { render, staticRenderFns } from "./TranslationGroup.vue?vue&type=template&id=398d0d4c&scoped=true&"
import script from "./TranslationGroup.vue?vue&type=script&lang=js&"
export * from "./TranslationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d0d4c",
  null
  
)

export default component.exports